import { render, staticRenderFns } from "./refund-detail.vue?vue&type=template&id=bce31c46&scoped=true"
import script from "./refund-detail.vue?vue&type=script&lang=js"
export * from "./refund-detail.vue?vue&type=script&lang=js"
import style0 from "./refund-detail.vue?vue&type=style&index=0&id=bce31c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2f37ed56e32c39bf37bd07aa5cbb5c73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce31c46",
  null
  
)

export default component.exports